import {Dimensions, StyleSheet} from 'react-native';
import {customResponsiveHeight} from '../../utils/CustomResponsive';
import {styles} from '../../theme';
const windowHeight = Dimensions.get('window').height;

export default StyleSheet.create({
  container: {
    width: '100%',
    height: windowHeight,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F34F42',
  },
  loading : {
    height: 24,
    width: 24,
    position: 'absolute',
  },
  text: {
    color: 'white',
    fontFamily: styles.font.IranYekan[400],
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 10,
  },
  checkNetFreeSpace: {
    height: 80,
  },
  netRow: {
    width: 290,
    alignSelf: 'center',
  },
  describe: {
    color: '#575757',
    textAlign: 'center',
    fontFamily: styles.font.IranYekan[700],
    fontSize: 14.5,
  },
  buttontext: {
    fontFamily: styles.font.IranYekan[700],
    fontSize: 18,
  },
  btncontainer: {
    width: '100%',
    paddingHorizontal: 10,
    alignItems: 'center',
    alignSelf: 'center',
  },
  percent: {
    textAlign: 'center',
    fontSize: 10,
    color: '#780e10',
    fontFamily: styles.font.IranYekan[400],
  },
  status: {
    textAlign: 'center',
    fontSize: 10,
    color: '#780e10',
    fontFamily: styles.font.IranYekan[400],
    marginBottom: 5,
  },
  version: {
    marginBottom: customResponsiveHeight(10),
    alignSelf: 'center',
    color: '#780e10',
  },
  textWrapper: {
    position: 'absolute',
    bottom: 0,
  },
});
